<app-auth-container>
    <div class="content-form__wrapper" content>
        <h2>Iniciar sesión</h2>
        <ng-container *ngIf="!loading; then signInForm else signInLoading"></ng-container>
    </div>
</app-auth-container>

<ng-template #signInForm>
    <form [formGroup]="formGroup" (ngSubmit)="onSignIn()" appBehaivorMenu>
        <div class="row center-xs">
            <div class="content-form__form">
                <div class="col-xs-12">
                    <mat-form-field class="form__field" appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" formControlName="email" name="email" placeholder="email@dominio.com" required>
                    </mat-form-field>
                    <mat-form-field class="form__field" appearance="outline">
                        <mat-label>Contraseña</mat-label>
                        <input matInput type="password" formControlName="password" name="password" placeholder="******" required>
                    </mat-form-field>
                </div>
                <div class="content-form__col-link col-xs-12">
                    <a routerLink="/auth/recoverpassword">¿Olvidaste tu contraseña?</a> 
                </div>
                <div class="col-xs-12">
                    <button type="submit" class="form__button" mat-raised-button [disabled]="formGroup.invalid">Iniciar Sesión</button>
                </div>
            </div>
        </div>
    </form>
</ng-template>

<ng-template #signInLoading>
    <app-loading message="Iniciando sesión..."></app-loading>
</ng-template>
